import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./style.css";
import { PopupDiv, GenericDiv } from "../Style";
const GCalendar = ({
  setDate,
  date,
  init,
  background = "linear-gradient(90deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%)",
}) => {
  return (
    <PopupDiv onClick={(e) => e.stopPropagation()}>
      <Calendar
        locale={"he"}
        onChange={setDate}
        value={date}
        style={{ paddingBottom: "20px" }}
      />
      <GenericDiv
        hoverBackground={"rgb(223, 223, 223)"}
        background={background}
        style={{
          borderRadius: "0px",
          width: "100%",
          fontSize: "16px",
          padding: "10px",
        }}
        onClick={() => {
          init(null);
        }}
      >
        שמירה
      </GenericDiv>
    </PopupDiv>
  );
};
export default GCalendar;
